import { api } from "../../lib/api/api";
import { args } from "../../lib/args/args";
import { expectShape } from "../../lib/expect/expect-shape";
import { is } from "../../lib/is/is";
import { followSession } from "../../lib/session/follow-session";
import { out } from "../../lib/output/out";
import { printSession } from "../../lib/session/print-session";
import { writeFollowedSessionOutcome } from "../../lib/session/write-followed-session-outcome";
import { createRunInput } from "@/commands/command/create-run-input";
import type { ApiOutputs } from "@/lib/api/api-outputs";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

/**
 * Exit code carries the outcome (0 done, 3 waiting on a human, 1 failed), so
 * a caller can drive the loop without parsing text.
 */
export async function runCommand(parsed: ParsedArgs): Promise<void> {
  args.expect(parsed, {
    flags: [
      "title",
      "task-type",
      "model",
      "harness",
      "repo",
      "branch",
      "skill",
    ],
    booleans: ["follow"],
    positional: 1,
  });

  const prompt = args.required(parsed, 0, "prompt");
  const asJson = parsed.booleans.has("json");
  const body = createRunInput(parsed, prompt);

  const session = expectShape<ApiOutputs["sessions"]["create"]>(
    await api("/sessions", { method: "POST", body }),
    "POST /sessions",
    { id: is.string, title: is.string, status: is.string },
  );

  if (!parsed.booleans.has("follow")) {
    if (asJson) {
      out.json(session);
      return;
    }
    printSession(session);
    out.line();
    out.line(out.paint(`  hepha sessions logs ${session.id} --follow`, "dim"));
    return;
  }

  const quiet = asJson || parsed.booleans.has("quiet");

  if (!quiet) {
    out.line(out.paint(`session ${session.id}`, "dim"));
    out.line();
  }

  const final = await followSession(session.id, { quiet });
  writeFollowedSessionOutcome(final, asJson);
}
